module.exports = __webpack_public_path__ + "static/media/whatsapp_button_off.4755f9fd.svg";